import React from "react";
import { inject, observer } from "mobx-react";
import { NaverTop } from "../../components/top/Top";
import { NaverTitle } from "../../components/title/Title";
import packIcon from "static-file/images/packIcon.png";
import tableIcon from "static-file/images/tableIcon.png";
import {
  PageContainer,
  PageContentContainer,
  PageTitleContainer,
  BizContainer,
  BizBottomContainer,
  BizItemRow,
} from "../../components/common";
import { Button } from "components/ui/Button";
import arrowBack from "static-file/images/arrowBack.png";
import { overlay } from "overlay-kit";
import { AlertModal } from "components/modal/AlertModal";
import { useHistory, useLocation } from "react-router";
import { useNaverBizItemQuery } from "views/naver/service/hooks/queries";
import { useNaverBizItemUpdateMutation } from "views/naver/service/hooks/mutations";
import { useNaverBizItemInvalidate } from "views/naver/hooks/useNaverInvalidate";

interface Props {
  rootStore?: any;
}

const NaverBizitemView = inject("rootStore")(
  observer(({ rootStore }: Props) => {
    const history = useHistory();
    const location = useLocation();
    const { searchStore } = rootStore;

    const urlParams = new URLSearchParams(location.search);
    const businessId = parseInt(urlParams.get("businessId") || "0");
    const connected = urlParams.get("connected") === "true";
    const invalidateNaverBizItem = useNaverBizItemInvalidate();

    // 주문 유형 조회
    const shopCd = searchStore.getShopCd;
    const { data: bizItem, isLoading: isLoadingBizItem } = useNaverBizItemQuery(rootStore, {
      shopCd,
      businessId: businessId,
    });

    // 주문 유형 설정
    const { mutate: setNaverBizItem } = useNaverBizItemUpdateMutation(rootStore);

    // API 데이터에서 매장/포장 정보 추출
    const bizItems = bizItem?.data || [];
    const visitItem = bizItems.find((item: any) => item.bizItemType === "VISIT"); // 매장
    const pickupItem = bizItems.find((item: any) => item.bizItemType === "PICKUP"); // 포장

    // 토글 변경 핸들러
    const handleToggleChange = (bizItemId: number, currentIsImp: boolean) => {
      setNaverBizItem(
        {
          businessId: businessId,
          shopCd,
          bizItemId: bizItemId,
          isImp: !currentIsImp, // 현재 상태의 반대로 설정
        },
        {
          onSuccess: data => {
            invalidateNaverBizItem();
          },
        }
      );
    };

    // 설정 완료
    const handleComplete = () => {
      overlay.open(({ isOpen, close }) => (
        <AlertModal
          open={isOpen}
          title="설정이 완료되었어요"
          subTit1="배달매니저 화면으로 이동할게요"
          leftBtnOnClick={close}
          leftBtnVariant="secondaryPrimary"
          leftBtnTxt="머무르기"
          rightBtnTxt="이동하기"
          rightBtnVariant="primaryWhite"
          rightBtnOnClick={() => {
            close();
            window.location.href = "/setting/default/receipt";
          }}
        />
      ));
    };

    // 매장 목록으로 돌아가기
    const handleBack = () => {
      history.push("/naver/connected");
    };

    if (isLoadingBizItem) {
      return <></>;
    }

    return (
      <>
        <NaverTop title="네이버 주문 연동" />
        <PageContainer>
          <PageContentContainer>
            <PageTitleContainer>
              <NaverTitle
                title="이용할 주문 유형을 설정해주세요"
                subTitle="이용하실 주문 유형 스위치를 ON으로 설정하셔야 네이버에 [주문하기] 버튼이 노출됩니다."
              />
            </PageTitleContainer>

            <BizContainer>
              {/* 포장 주문 */}
              {pickupItem && (
                <BizItemRow
                  iconSrc={packIcon}
                  iconAlt="packIcon"
                  title={"포장"}
                  checked={pickupItem.isImp}
                  onChange={() => handleToggleChange(pickupItem.bizItemId, pickupItem.isImp)}
                />
              )}

              {/* 매장 주문 */}
              {visitItem && (
                <BizItemRow
                  iconSrc={tableIcon}
                  iconAlt="shopIcon"
                  title={"매장(테이블 주문)"}
                  checked={visitItem.isImp}
                  onChange={() => handleToggleChange(visitItem.bizItemId, visitItem.isImp)}
                />
              )}
            </BizContainer>

            <BizBottomContainer>
              {connected ? (
                <Button
                  fullWidth={false}
                  variant="secondaryLight"
                  size="sm"
                  padding="12px 16px"
                  className="flex align-middle gap-2"
                  onClick={handleBack}
                >
                  <img src={arrowBack} alt="arrowBack" />
                  <span>매장 목록으로 돌아가기</span>
                </Button>
              ) : (
                <Button fullWidth={false} variant="primaryWhite" size="sm" padding="12px 16px" onClick={handleComplete}>
                  설정 완료
                </Button>
              )}
            </BizBottomContainer>
          </PageContentContainer>
        </PageContainer>
      </>
    );
  })
);

export default NaverBizitemView;
